module.exports = __webpack_public_path__ + "media/icon_transaction/hedgehog_1-9aef8a92.png";